/**
 * Form field groups, labels, and spacing — reusable across flows.
 * @see atomicRules.ts
 */
import { ViewStyle, TextStyle } from 'react-native';
import { appTheme } from '../appTheme';

export const formSection: ViewStyle = {
  backgroundColor: appTheme.colors.surface,
  marginTop: appTheme.spacing.md,
  paddingHorizontal: appTheme.spacing.lg,
  paddingVertical: appTheme.spacing.lg,
  borderRadius: appTheme.borderRadius.md,
  borderWidth: 1,
  borderColor: (appTheme.colors.primary || '#888') + '22',
  ...appTheme.shadows.xs,
};

export const inputGroup: ViewStyle = {
  marginBottom: appTheme.spacing.md,
};

export const formFieldGap: ViewStyle = {
  marginBottom: appTheme.spacing.xl,
};

export const inputContainerFlush: ViewStyle = {
  marginBottom: 0,
};

/**
 * Two fields on one row (e.g. first + last name). Pair each `Input` with `formFieldHalf`.
 * Used by: `RegisterSheetContent`.
 */
export const formFieldRow: ViewStyle = {
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: appTheme.spacing.md,
  width: '100%',
};

export const formFieldHalf: ViewStyle = {
  flex: 1,
  minWidth: 0,
};

export const sectionInset: ViewStyle = {
  marginTop: appTheme.spacing.md,
  paddingHorizontal: appTheme.spacing.lg,
};

export const formLabel: TextStyle = {
  ...appTheme.typography.bodySmall,
  fontWeight: '500',
  marginBottom: appTheme.spacing.xs,
};
